import Vue from 'vue';
import Vuex from 'vuex';

import shared from './modules/shared';
import users from './modules/users';
import posts from './modules/posts';
import groups from './modules/groups';
import groupSelected from './modules/groupSelected';
import categories from './modules/categories';
import usertypes from './modules/usertypes';
import managerole from './modules/managerole';
import transactions from './modules/transactions';
import userperms from './modules/userperms';
import cards from './modules/cards';
import budgets from './modules/budgets';
import company from './modules/company';
import merchant from './modules/merchant';
import payment from './modules/payment';
import eCCTransactions from './modules/eCCTransactions';
import tags from './modules/tags';
import superAdmin from './modules/superAdmin';
import journal_entry from './modules/journal_entry';

import receiptDownload from './modules/receiptDownload';

// static
import staticEmployees from './modules/staticEmployees';
import staticTeams from './modules/staticTeams';
import staticCategories from './modules/staticCategories';
import Home from './modules/dashboard';
import staticPages from './modules/staticPages';
import staticChart from './modules/staticChart';
import selectdate from './modules/selectdate';
import manageAccount from './modules/manageAccount';
import accounting from './modules/accounting';
import quickBook from './modules/quickBook';
import sentinelInsights from './modules/sentinelInsights';
import agilLink from './modules/agilLink';
import agilLinkOnline from './modules/agilLinkOnline';
import xero from './modules/xero';
import signInCode from './modules/signInCode';
import notification from './modules/notification';


Vue.use(Vuex);

export default new Vuex.Store({
  // to fix below error turn "strict" to "false"
  // Error: [vuex] Do not mutate vuex store state outside mutation handlers
  // read more here: https://vuex.vuejs.org/guide/strict.html
  strict: false,

  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    posts,
    users,
    shared,
    groups,
    groupSelected,
    categories,
    usertypes,
    managerole,
    transactions,
    receiptDownload,
    userperms,
    cards,
    budgets,
    company,
    superAdmin,
    merchant,
    // dashboard,
    // static
    staticEmployees,
    staticTeams,
    staticCategories,
    Home,
    staticPages,
    staticChart,
    selectdate,
    manageAccount,
    accounting,
    quickBook,
    sentinelInsights,
    xero,
    agilLink,
    agilLinkOnline,
    payment,
    signInCode,
    eCCTransactions,
    tags,
    notification,
    journal_entry,
  },
});
